import React from "react";

const CopyRight = () => {
  return (
    <div className="copyright">
      <p>
        &copy; {new Date().getFullYear()}· Created by
        <a
          href="https://amaren.ventures"
          target="_blank"
          rel="noreferrer"
        >
          Amaren Ventures
        </a>
        <br />
      </p>
    </div>
  );
};

export default CopyRight;
